module.exports = __webpack_public_path__ + "img/banner01.809f7f91.jpg";